<template>
    <div class="row">
        <div class="col-12 mb-2">
            <button type="button" class="btn btn-link p-0" @click="useFirstPassengerData">
                {{ $t('taxi.pages.summary.use_first_passenger_data') }}
            </button>
        </div>

        <div class="col-12 col-sm-6 mb-2">
            <div class="mb-1 is-required">
                {{ $t('first_name') }}:
            </div>

            <div>
                <input
                    class="form-control"
                    required
                    :value="purchaser.purchaser_first_name"
                    maxlength="20"
                    @input="onInput($event, 'purchaser_first_name')"
                >
            </div>
        </div>

        <div class="col-12 col-sm-6 mb-2">
            <div class="mb-1 is-required">
                {{ $t('last_name') }}:
            </div>

            <div>
                <input
                    class="form-control"
                    required
                    :value="purchaser.purchaser_last_name"
                    maxlength="30"
                    @input="onInput($event, 'purchaser_last_name')"
                >
            </div>
        </div>

        <div class="col-12 col-sm-6 mb-2">
            <div class="mb-1 is-required">
                {{ $t('email') }}:
            </div>

            <div>
                <input
                    type="email"
                    class="form-control"
                    required
                    :value="purchaser.purchaser_email"
                    @input="onInput($event, 'purchaser_email')"
                >
            </div>

            <div class="text-xs text-muted">
                {{ $t('taxi.pages.summary.email_tooltip') }}
            </div>
        </div>

        <div class="col-12 col-sm-6 mb-2">
            <div class="mb-1 is-required">
                {{ $t('phone_number') }}:
            </div>

            <div>
                <phone-input
                    input-class="form-control"
                    :required="true"
                    :value="purchaser.purchaser_phone"
                    @input="onPhoneInput($event)"
                />
            </div>

            <div class="text-xs text-muted">
                {{ $t('taxi.pages.summary.phone_number_tooltip') }}
            </div>
        </div>

        <div v-if="false">
            <div class="col-12 mt-3" v-if="!isLoggedIn">
                <label class="m-0">
                    <input type="checkbox" class="mr-1" :checked="isCheckedCreateAccount" @change="onCreateAccountInput">
                    {{ $t('taxi.pages.summary.create_user_account') }}
                </label>
            </div>

            <div class="col-12 col-sm-6 mb-2" v-if="isCheckedCreateAccount">
                <div class="mb-1 mt-2 is-required">
                    {{ $t('auth.password') }}:
                </div>

                <div>
                    <input type="password" class="form-control" required @input="onPasswordInput">
                </div>
            </div>

            <div class="col-12 col-sm-6 mb-2" v-if="isCheckedCreateAccount">
                <div class="mb-1 mt-2 is-required">
                    {{ $t('auth.confirm_password') }}:
                </div>

                <div>
                    <input type="password" class="form-control" required @input="onConfirmPasswordInput">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import { updateClone } from '@utilities/object';

    export default {
        computed: {
            ...mapGetters({
                purchaser: 'berbus/getPurchaser',
                isCheckedCreateAccount: 'berbus/isCheckedCreateAccount',
                passengers: 'berbus/getPassengers',
                userEmail: 'user/getEmail',
                userPhone: 'user/getPhone',
                isLoggedIn: 'user/isLoggedIn',
            }),
        },

        created() {
            if (!this.purchaser.purchaser_email && this.userEmail) {
                this.setPurchaserField('purchaser_email', this.userEmail);
            }

            if (!this.purchaser.purchaser_phone && this.userPhone) {
                this.setPurchaserField('purchaser_phone', this.userPhone);
            }
        },

        methods: {
            onInput(event, field) {
                this.setPurchaserField(field, event.target.value);
            },

            onPhoneInput(value) {
                this.setPurchaserField('purchaser_phone', value);
            },

            setPurchaserField(field, value) {
                const details = updateClone(this.purchaser, field, value);
                this.$store.dispatch('berbus/setPurchaser', details);
            },

            onCreateAccountInput(event) {
                const value = event.target.checked;

                this.$store.dispatch('berbus/setIsCheckedCreateAccount', value);
            },

            onPasswordInput(event) {
                this.$store.dispatch('berbus/setPassword', event.target.value);
            },

            onConfirmPasswordInput(event) {
                this.$store.dispatch('berbus/setPasswordConfirmation', event.target.value);
            },

            useFirstPassengerData() {
                this.setPurchaserField('purchaser_first_name', this.passengers[0].first_name);
                this.setPurchaserField('purchaser_last_name', this.passengers[0].last_name);
                this.setPurchaserField('purchaser_phone', this.passengers[0].phone);
            },
        },
    };
</script>
